module.exports = {
  key: "dashboard",
  attribute: {
    fullName: "نام کامل",
    nationalCode: "کد ملی",
    level: "سطح",
    levelType: "رشته و گرایش",
    birthday: "تاریخ تولد",
    lastMajor: "آخرین مدرک تحصیلی",
    address: "آدرس",
    postalCode: "کد پستی",
    personalPhoto: "عکس پرسنلی",
    nationalCartPhoto: "عکس کارت ملی",
    howToSend: "نحوه ارسال",
    startTime: "تاریخ صدور",
    pay: "پرداخت",
    edit: "تغییر",
    Post: "پست",
    Terminal: "ترمینال",
    Tpax: "تیپاکس",
    Diplom: "دیپلم",
    FogDiplom: "فوق دیپلم",
    Lisans: "لیسانس",
    FogLisans: "فوق لیسانس",
    Doctora: "دکتری",
    send: "ارسال",
    cancel: "لغو",
    payId: "فیش پرداختی",
    admin_text: "پیام ادمین",
    show_cert: "مشاهده ی مدرک",
    mobileNumber: "شماره تلفن همراه",
    register_date: "تاریخ عضویت",
    user_type: "کاربر",
    is_admin_true: "ادمین",
    is_admin_false: "عادی",
    olPassword: "کلمه ی عبور قدیمی",
    newPassword: "کلمه ی عبور جدید",
    reset_password: "تغییر کلمه عبور"
  },
  placeholder: {
    lastMajor_ex: "مثال: لیسانس",
    levelType_ex: "مثال: مکانیک - نگه داری ماشین ها",
  },
};
